module.exports = __webpack_public_path__ + "static/media/facebook.6e28aee3.svg";